var MDB = window.MDB || {};
MDB.Mangl = MDB.Mangl || {};
MDB.Mangl.Recordings = MDB.Mangl.Recordings || {};

(function ($) {
    $.extend(MDB.Mangl.Recordings, {
        _formatIOItemDefinitionsHtml: function(definitions){
            var container = $('<div class="row"></div>');
            var rowTemplate  = 
                '<div class="col-12">' +
                    '<div class="row"> ' +
                        '<div class="col-5"><label class="control-label">%s</label></div>' +
                        '<div class="col-2"><label class="control-label">%s</label></div>' +
                        '<div class="col-5"><label class="control-label">%s</label></div>' +
                    '</div>' +
                '</div>';

            definitions = _.concat([{
                ExternalName: MDB.loadResourceString('IOItemDefinitionModel_ExternalName_DisplayName'),
                ExternalIndex: MDB.loadResourceString('IOItemDefinitionModel_ExternalIndex_DisplayName'),
                ExampleValue: MDB.loadResourceString('IOItemDefinitionModel_ExampleValue_DisplayName')
            }], definitions);
            
            var rows = _.map(definitions, function (definition) {
                return sprintf(rowTemplate, 
                    definition.ExternalName || '', 
                    _.isUndefined(definition.ExternalIndex) ? '' : definition.ExternalIndex, 
                    definition.ExampleValue || ''
                );
            });
            
            container.append(rows);
            
            return container;
        },
        
        bootImport: function (model) {
            var ioFormatDropdown = $('#IoFormatId')
                , divisionDropdown = $('#DivisionId')
                , ioFormatContainer = $('#io-format-container')
                , viewFormatDefinitionButton = $('#view-format-definition');
            
            divisionDropdown.on('change', function () {
                var availableFormats = model.ioFormats[this.value];
                ioFormatDropdown.empty();
                
                if (!availableFormats || !availableFormats.length){
                    ioFormatContainer.hide();
                    return;
                }

                ioFormatContainer.show();
                
                ioFormatDropdown.append(
                    _.map(availableFormats, function (format) {
                        return sprintf('<option value="%s">%s</option>', format.value, format.text)
                    } )    
                )
            });
            
            //In case no value was preselected, ensure the IOFormat dropdown is loaded
            if (!divisionDropdown.val() !== model.divisionId) {
                divisionDropdown.trigger('change');
            }

            viewFormatDefinitionButton.on('click', function (e) {
                e.preventDefault();

                var getIoDefinitionPromise = MDB.IoFormat.getFormatItemDefinitions(ioFormatDropdown.val());

                MDB.modal({
                    shapeHtml: function (modal) {
                        getIoDefinitionPromise.success(function (definitions) {
                            var importDefinitions = _.filter(definitions, function (definition) {
                                return definition.Type === 'ImportValue' && _.isNumber(definition.ExternalIndex);
                            });
                            
                            
                            $(modal).find('.modal-body').html(MDB.Mangl.Recordings._formatIOItemDefinitionsHtml(importDefinitions));
                        })
                    }
                });
                
                getIoDefinitionPromise.error(function (err) {
                    MDB.alert('Er is iets misgegaan, probeer het opnieuw');
                });
            });
            
            
            if (window.FormData){
                $('.upload-form').on('submit', function(e) {
                    e.preventDefault();

                    var me = this
                        , $me = $(me)
                        , progress = $('.upload-progress');
                    
                    progress.width('100%');
                    
                    if($me.data('uploading')) {
                        return;
                    }

                    $me.data('uploading', true);

                    progress.removeClass('hidden');

                    $.ajax({
                        url: me.action,
                        method: me.method,
                        data: new FormData(me),
                        processData: false,
                        contentType: false,
                        success: function(id) {
                            location.href = '/MANGL/Import/RecordingImport/' + id;
                        },
                        error: function () {
                            progress.attr('value', 0);
                            $me.data('uploading', false);
                            
                            MDB.alert('Er is iets misgegaan, probeer het opnieuw');
                        },
                        xhr: function(){
                            //https://stackoverflow.com/a/20984502
                            var xhr = $.ajaxSettings.xhr();
                            xhr.upload.onprogress = function(e) {
                                if (e.lengthComputable) {
                                    progress.attr('value', ((e.loaded/e.total) * 100));
                                }
                            };

                            return xhr;
                        }
                    });
                });   
            }
        }
    })
}(jQuery));